
import { Technician } from "@/store/modules";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class AuthRegisterButton extends Vue {
  @Prop(Technician)
  private record!: Technician;

  @Prop(Boolean)
  loading = false;

  savingText = "Saving";

  showModal = false;

  email = "";
  password = "";
  confirmPassword = "";

  saving = false;

  error: string | null = null;
  success: string | null = null;

  showPassword = false;
  showConfirmPassword = false;

  get serverError() {
    console.log("serverError", this.$store.state);
    return this.$store.state.entities.technician.error;
  }

  mounted() {
    this.$nextTick(() => {
      const { cognito_email, cognitoID } = this.record;
      if (cognito_email) {
        this.email = cognito_email;
      }
    });
  }

  get text() {
    const { cognitoID } = this.record;
    return cognitoID ? "Register" : "Add cognito ID";
  }

  onCloseModal() {
    this.showModal = false;
    this.success = null;
    this.error = null;
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  async onSave() {
    this.error = null;
    this.success = null;
    // if (!this.email) {
    //   this.error = "Missing email";
    // }

    if (!this.password) {
      this.error = "Missing password";
    }

    if (this.password.length < 8) {
      this.error = "Must be atleast 8 characters long";
    }

    if (this.password !== this.confirmPassword) {
      this.error = "Passwords do not match";
    }

    if (this.error) {
      return;
    }

    this.saving = true;

    const r = await Technician.dispatch("forcePasswordChange", {
      email: this.email,
      password: this.password,
      confirmPassword: this.confirmPassword,
    });

    console.log('rr', r, this.$store.state.entities.technician.error)
    this.error = null;
    if (
      this.$store.state.entities.technician.error &&
      this.$store.state.entities.technician.error.length
    ) {
      this.error =
        this.$store.state.entities.technician.error[0].message.join(" ");
    }
    this.saving = false;
    if (!this.error) {
      this.success = "Password changed successfully!";
      this.password = '';
      this.confirmPassword = '';
      
      // Close modal after a brief delay to show success message
      setTimeout(() => {
        this.toggleModal();
        this.success = null;
      }, 2000);
    }

    this.$emit("on-saved", this.record.ID);
  }

}

export default AuthRegisterButton;
